/** * 预约医生列表 */
<template>
  <div class="appointment-schedule-department">
    <AppointmentScheduleDateArea @changeDate="changeDate" />
    <div class="appointment-schedule-department-show-empty">
      <span>仅显示可预约的医生</span>
      <van-switch v-model="hideEmpty" size="1.2rem" />
    </div>
    <div class="appointment-schedule-department-list">
      <ph-empty v-if="!getDoctorList.length" />
      <div
        v-for="item in getDoctorList"
        :key="item.id"
        class="appointment-schedule-department-list-item"
      >
        <div
          @click="showDetail(item)"
          class="appointment-schedule-department-list-item-doctor-info"
        >
          <van-image :src="item.portrait" class="doctor-protrait" alt="">
            <img slot="error" :src="require('@assets/ic_doctor.png')" alt="" />
          </van-image>
          <!-- <img v-lazy="item.portrait" /> -->
          <div>
            <span>{{ `${item.doctorName} ${item.title}` }}</span>
            <p class="van-multi-ellipsis--l2">{{ item.introduction }}</p>
          </div>
        </div>
        <AppointmentScheduleDate
          :doctor-info="item"
          :list="item.dateList"
          :hide-empty="hideEmpty"
          :qrtype="qrtype"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppointmentScheduleDate from "./components/AppointmentScheduleDate";
import AppointmentScheduleDateArea from "./components/AppointmentScheduleDateArea";

export default {
  components: {
    AppointmentScheduleDate,
    AppointmentScheduleDateArea
  },
  data() {
    return {
      currentDate: "",
      pageInfo: {},
      doctorList: [],
      value: 0,
      dateList: [],
      hideEmpty: false,
      qrtype: "1",
      startDate: "",
      endDate: ""
    };
  },
  computed: {
    getDoctorList() {
      if (this.hideEmpty) {
        const list = this.doctorList.map(doctor => {
          const dates = doctor.dateList.filter(item => item.remain !== "0");
          return {
            ...doctor,
            dateList: dates
          };
        });
        return list.filter(item => item.dateList.length);
      }
      return this.doctorList;
    }
  },
  created() {
    this.qrtype = this.$route.query.qrtype || "1";
    this.pageInfo = this.$route.query;
    this.startDate = this.$moment().format("YYYYMMDD");
    this.endDate = this.$moment()
      .add(10, "day")
      .format("YYYYMMDD");
    this.initDoctorList();
  },
  methods: {
    initDoctorList() {
      this.$http
        .post(this.$api.APPOINTMENT_DOCTOR_SCHEDULE_LIST, {
          appointOfficeCode: this.pageInfo.id,
          startDate: this.startDate,
          endDate: this.endDate
        })
        .then(res => {
          this.doctorList = res.map(item => {
            return {
              portrait: item.photourl,
              doctorName: item.appointDoctorName,
              doctorId: item.appointDoctorCode,
              title: item.levelName,
              introduction: item.intro,
              departmentName: item.appointOfficeName,
              departmentId: item.appointOfficeCode,
              dateList: item.appointmentList
            };
          });
        })
        .catch(() => {
          this.doctorList = [];
        });
    },
    changeDate({ startDate, endDate }) {
      this.startDate = startDate;
      this.endDate = endDate;
      this.initDoctorList();
    },
    // 跳转医生明细
    showDetail(item) {
      this.$router.push({
        name: "doctor-detail",
        query: {
          doctorNo: item.doctorId,
          nobutton: true
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.appointment-schedule-department {
  overflow: hidden;
  // background: @primary-gray;

  &-show-empty {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
  }

  &-list {
    height: calc(100% - 6.2rem);
    overflow: scroll;
    &-item {
      margin: 0.5rem;
      border-bottom: 1px solid #dcdcdc;

      &-doctor-info {
        display: flex;
        width: 100%;
        font-size: 0.9rem;

        .doctor-protrait {
          flex-shrink: 0;
          margin: 0 0.8rem;
          overflow: hidden;
          border-radius: 50%;
        }

        p {
          margin: 0;
          color: #959595;
          font-size: 0.7rem;
        }
      }
    }
  }
}

.date-list {
  display: flex;
  overflow-x: scroll;
  white-space: nowrap;

  > div {
    width: 5rem;
    margin: 0.2rem;
    padding: 0.5rem;
    color: white;
    font-size: 0.85rem;
    text-align: center;
    background: #c1bfb7;
    border-radius: 0.2rem;
  }

  .selected {
    background: #6596f2;
  }
}
</style>
